import { Controller } from "@hotwired/stimulus"

// Hält den „Anruf starten“-Link mit einer Nummern-Auswahl synchron (Phonecall-Modal, mehrere Rufnummern).
export default class extends Controller {
  static targets = ["telLink", "select"]
  static values = {
    prefix: { type: String, default: "tel" }
  }

  connect() {
    this.syncTel()
  }

  syncTel() {
    if (!this.hasSelectTarget) return
    const href = this.buildHref(this.selectTarget.value || "")

    if (this.hasTelLinkTarget) this.telLinkTarget.href = href

    // Auch markierte Anruf-Links außerhalb des Controller-Scopes (z. B. der
    // "Jetzt anrufen"-Button im Kopf des Anruf-Modals) mit der gewählten
    // Nummer synchron halten.
    const scope = this.element.closest('.tmodal') || this.element.closest('form')?.parentElement || document
    scope.querySelectorAll('a[data-phonecall-dial-link]').forEach((a) => { a.href = href })
  }

  buildHref(raw) {
    const cleaned = (raw || "").replace(/\s+/g, "")
    if (!cleaned) return "#"
    return `${this.prefixValue}:${cleaned}`
  }
}
